import styles from '../neon-wallets.module.scss'

const STEPS = [
  'Scan the QR code or copy the address',
  'Send SOL and USDT on the Solana network',
  'Watch the goals light up: the balance updates here by itself'
]

export const DepositSteps: React.FC = () => (
  <ol className={styles.steps}>
    {STEPS.map((step, index) => (
      <li
        key={step}
        className={styles.step}
      >
        <span className={styles.stepNumber}>{index + 1}</span>
        <span>{step}</span>
      </li>
    ))}
  </ol>
)
